import { useEffect, useRef, useState } from 'react'

type UseInvoicesSkeletonVisibilityInput = {
  invoicesLoading: boolean
  minVisibleMs?: number
}

export const useInvoicesSkeletonVisibility = ({
  invoicesLoading,
  minVisibleMs = 760,
}: UseInvoicesSkeletonVisibilityInput) => {
  const [invoicesSkeletonVisible, setInvoicesSkeletonVisible] = useState(() => invoicesLoading)
  const invoicesLoadingStartedAtRef = useRef<number | null>(invoicesLoading ? Date.now() : null)

  useEffect(() => {
    if (invoicesLoading) {
      invoicesLoadingStartedAtRef.current = Date.now()
      setInvoicesSkeletonVisible(true)
      return
    }

    if (!invoicesSkeletonVisible) return

    const loadingStartedAt = invoicesLoadingStartedAtRef.current ?? Date.now()
    const elapsed = Date.now() - loadingStartedAt
    const remaining = Math.max(minVisibleMs - elapsed, 0)

    const timeoutId = window.setTimeout(() => {
      setInvoicesSkeletonVisible(false)
      invoicesLoadingStartedAtRef.current = null
    }, remaining)

    return () => window.clearTimeout(timeoutId)
  }, [invoicesLoading, invoicesSkeletonVisible, minVisibleMs])

  return invoicesSkeletonVisible
}
